import './user-programs.scss';
import React, {useContext, useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import Loading from "../../../components/UI/Loading/Loading";
import {PortfolioContext} from "../../../hooks/Context/PortfolioContext";
import UserProgramsEmpty from "./UserProgramsEmpty";
import UserPrograms from "./UserPrograms";
import {UserContext} from "../../../hooks/Context/UserContext";
import {useLocation} from "react-router-dom";
import {toast} from "react-toastify";
import {useQueryUserInfo} from '../../../api/admin/useQueryUserInfo';

const UserProgramsRoute = () => {
  const [user] = useContext(UserContext);
  const [portfolio, setPortfolio] = useContext(PortfolioContext);
  const location = useLocation();
  const navigate = useNavigate();
  const {refetch: refetchPortfolio, data: portfolio_data} = useQueryUserInfo({
    portfolio_id: portfolio.id
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const successfulPayment = queryParams.get('payment_intent');
    const handleSuccessfulPayment = () => {
      refetchPortfolio().then(response => {
        if (response.data) {
          setPortfolio({
            ...response.data,
          })
        }
      }).finally(
        () => {
          toast.success('Payment was successful!', {toastId: 'payment-success'});
          navigate(location.pathname);
        }
      )
    }

    if (successfulPayment) {
      (async () => {
        await setTimeout(handleSuccessfulPayment, 1000);
      })();
    }
  }, [location]);

  if (!portfolio.status && !user.isSoft) {
    return <Loading loading />
  }

  if ((!portfolio.id || !portfolio.portfolio_email) && !user.isSoft) {
    return <UserProgramsEmpty />
  }

  return <UserPrograms />
}

export default UserProgramsRoute;